<template>
  <div class="container">
    <span class="landscape_error" v-show="$store.getters['app/overlays'].show_landscape_error">
      <p id="text_error">Please set device to landscape</p>
    </span>

    <span v-show="$store.getters['app/overlays'].show_start_menu_overlay">
      <img v-if="start" draggable="false" class="clickable shadow" id="quit_btn_top" @click="selectHomeScreen()" src="./assets/images/Asset 30.png" alt="">
      <img draggable="false" class="background_image" src="./assets/images/Asset 37.png" alt="">

      <span v-if="selected_text == -1">
        <p id="main_text">X11</p>
        <p id="books_text"><u>Verhaal boeken van Indra Hu:</u></p>

        <img draggable="false" id="book_1_image" class="book shadow clickable" @click="goToBook1()" src="./assets/images/book_1.jpg" alt="">
        <img draggable="false" id="book_2_image" class="book shadow clickable" @click="goToBook2()" src="./assets/images/book_2.jpg" alt="">

        <img class="clickable" @click="backToIntro()" draggable="false" id="quit_btn" src="./assets/images/Asset 29.png" alt="">
        
        <p id="text_1"><u>Klik hier om meerdere verhalen van te lezen:</u></p>
        <img class="clickable shadow" @click="goToLink()" draggable="false" id="link_btn" src="./assets/images/Asset 63.png" alt="">

        <p id="text_2"><u>Zing met je familie en vrienden het Sranan Krakti thema lied:</u></p>
        <img class="clickable shadow" @click="goToKaraoke()" draggable="false" id="karaoke_btn" src="./assets/images/Asset 64.png" alt="">
      </span>

      <span v-if="selected_text > -1">
        <span v-if="selected_text == 0" id="text_intro_header" v-html="head_text"></span>
        <p v-html="texts[selected_text]" id="intro_text" :style="selected_text > 0 ? 'margin-top: 6%;' : ''"></p>
      </span>
    </span>
    
    <router-view/>
  </div>

</template>

<script>

export default {
  name: 'App',

  mounted() {
    this.selectDefault()
    this.checkLandscape()

    document.getElementsByTagName('body')[0].style.backgroundColor = ''
  },

  created() {
    window.addEventListener("resize", this.checkLandscape);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkLandscape);
  },

  data() {
    return {
      start: true,
      selected_text: -1,
      texts: [
        ""
      ],
      head_text: ""
    };
  },

  methods: {
    goToStartPage() {
      this.$router.push('/start');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },

    backToIntro() {
      this.selected_text = 0
      this.start = true
      this.selectDefault()
    },

    goToLink() {
      window.open('https://arkiwantori.sr/', '_blank');
    },

    goToBook1() {
      this.$router.push('/book/1');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },
    goToBook2() {
      this.$router.push('/book/2');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },
    goToKaraoke() {
      this.$router.push('/karaoke');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },

    selectDefault() {
      this.selected_text = 0;
      this.head_text = "";
      this.texts = [
        "Er zijn verschillende manieren waarop wij ons creatief kunnen uiten zoals schrijven, zingen, acteren, schilderen, dansen en nog veel meer. In X11 kan je kennis maken met andere Sranan Krakti die goed zijn in een bepaalde vorm van zelfexpressie. Ontdek enkele vormen en de kracht van expressie. Op welke manier uit jij jouw gedachten, gevoel en mening op een creatieve manier?"
      ];
    },
    selectHomeScreen() {
      this.start = false
      this.selected_text = -1;
      this.head_text = "";
      this.texts = [
        ""
      ];
    },
    checkLandscape() {
      if ( window.innerWidth < ( window.innerHeight * 1.5 ) ) {
        if ( ! this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: true
          });
      } else {
        if ( this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: false
          });
      }
    }
  },

  computed: {},

  watch: {}
}
</script>

<style>
  .landscape_error {
    background-color: grey;
    width: 105%;
    height: 105%;
    position: absolute;
    z-index: 3;
  }

  #text_error {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    color: white;
    width: 95%;
    font-size: 5.5vw;
    text-align: center;
  }

  @font-face {
    font-family: "LuckiestGuy";
    src: url('./assets/x11/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  #text_intro_header {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 6%;
    width: 50%;
    left: 25%;
    color: #fff;
    font-size: 5vw;
    text-align: center;
  }
  #intro_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 13%;
    width: 60%;
    left: 20%;
    color: #fff;
    font-size: 2vw;
    text-align: center;
  }

  .background_image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

  #book_1_image {
    position: absolute;
    margin-top: 20%;
    left: 5%;
    width: 17%;
    height: auto;
  }

  #book_2_image {
    position: absolute;
    margin-top: 20%;
    left: 25%;
    width: 17%;
    height: auto;
  }

  .book {
    border-radius: 20px;
  }

  .shadow {
    filter: drop-shadow(5px 2px 7px #3d3d3d);
    -webkit-filter: drop-shadow(5px 2px 7px #3d3d3d);
  }

  #main_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 3%;
    width: 60%;
    left: 20%;
    font-size: 6.5vw;
    text-align: center;
    color: white;
  }

  #books_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 14%;
    width: 37%;
    left: 5%;
    font-size: 2.5vw;
    text-align: center;
    color: white;
  }

  #text_1 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 14.5%;
    width: 46%;
    left: 50%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }
  #text_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 30%;
    width: 46%;
    left: 50%;
    font-size: 1.5vw;
    text-align: center;
    color: white;
  }

  body {
    cursor: url('./assets/cursor/material-wood-cursor.png'), default;	
  }

  #start_btn {
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
    position: absolute;
    margin-top: 17%;
    left: 30%;
    width: 20%;
  }

  .clickable:hover {
    opacity: 0.7;
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;	
  }

  #quit_btn {
    position: absolute;
    margin-top: 1%;
    right: 3%;
    width: 20%;
  }
  #link_btn {
    position: absolute;
    margin-top: 18%;
    right: 17%;
    width: 20%;
  }
  #karaoke_btn {
    position: absolute;
    margin-top: 34%;
    right: 17%;
    width: 20%;
  }

  #quit_btn_top {
    position: absolute;
    margin-top: 2%;
    right: 3%;
    width: 15%;
    z-index: 1;
  }
  #quit_btn_top_for_intro {
    position: absolute;
    margin-top: 2%;
    right: 3%;
    width: 15%;
    z-index: 100;
  }

  p {
    filter: drop-shadow(5px 2px 7px #3d3d3d);
    -webkit-filter: drop-shadow(5px 2px 7px #3d3d3d);
  }

  body {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
</style>
